import React from 'react';

import { Typography } from '@mui/material';
import { Link } from 'react-router';

import type { SxProp } from 'src/types/mui';

type BreadcrumbPathProps = {
  title: string;
  path: string;
  isCurrentRoute?: boolean;
};

export const BreadcrumbPath: React.FC<BreadcrumbPathProps> = ({
  title,
  path,
  isCurrentRoute = true,
}) => {
  return (
    <Typography
      variant="body1"
      sx={typographyStyles}
      component={isCurrentRoute ? 'div' : Link}
      to={isCurrentRoute ? undefined : path}
    >
      {title}
    </Typography>
  );
};

const typographyStyles: SxProp = theme => ({
  textDecoration: 'none',
  color: theme.palette.text.secondary,
});
